import React, { useEffect, useState } from 'react'
import Wrapper from './wrapper'
import { useDebouncedCallback } from 'use-debounce'
import { isEmpty } from '~/prix/utils/empty'
import { Input } from '../../input'

export default function NumberField({
  label,
  tests = [],
  id,
  value,
  onDirectChange,
  onBlur,
  wrapperProps = {},
  wrapperClassName,
  className = 'input',
  isMultiple,
  ...props
}: {
  label?: string
  tests?: any
  id?: string
  value: any
  onDirectChange: (value: any) => void
  onBlur?: () => void
  wrapperProps?: any
  wrapperClassName?: string
  className?: string
  isMultiple?: boolean
  [key: string]: any
}) {
  const isRequired = tests.find((item: any) => item.name === 'required')
  const [realValue, setRealValue] = useState(isEmpty(value) ? '' : Number(value))
  const debounced = useDebouncedCallback(
    (newValue: any) => onDirectChange(isEmpty(newValue) ? null : Number(newValue)),
    1000,
  )

  useEffect(() => {
    setRealValue(isEmpty(value) ? '' : Number(value))
  }, [value])

  const min = tests.find((item: any) => item.name === 'min')
  const max = tests.find((item: any) => item.name === 'max')

  return (
    <Wrapper
      wrapperClassName={wrapperClassName}
      isRequired={isRequired}
      tests={tests}
      label={label}
      id={id}
      {...wrapperProps}
    >
      <Input
        {...props}
        type='number'
        id={id}
        value={realValue}
        onChange={event => {
          const newValue = Number(event.target.value)
          setRealValue(newValue)
          debounced(newValue)
        }}
        onBlur={onBlur}
        autoComplete='off'
        className={className}
        min={min ? min.params.min : undefined}
        max={max ? max.params.max : undefined}
      />
    </Wrapper>
  )
}
